import Popup from "../../lib/Popup";

import * as PIXI from "pixi.js";
import gsap from "gsap";
import { IGameSnacks } from "../../lib/GameSnacks";
import ServiceLocator from "../../ServiceLocator";
import Button from "../../lib/Button";
import { Profile } from "../../lib/game_snacks/IUser";
import Session from "../../Session";
import { LiveEventData, LiveEventDataType, LivePlayerDataEvent, LivePresenceAction } from "../../lib/game_snacks/ILiveMultiplayer";
import { Signal } from "signals";
import PRNG from "../../lib/PRNG";
import PlayerSlot from "./PlayerSlot";
import { game_event_type } from "../../service/MultiplayerEventManager";
import Settings from "../Settings";
import TutorialPopup from "./TutorialPopup";
import MatchmakingReadyAnim from "./MatchmakingReadyAnim";

declare global {
    interface Window { GameSnacks: IGameSnacks; }
}


export default class HostPrivateRoomPopup extends Popup
{
    // #region Attributes //

    // private:

    private _url: string = null;

    private _matchmakingReadyAnim: MatchmakingReadyAnim = null;
    private _headerText: PIXI.Text = null;
    private _magnifyingGlass: PIXI.Sprite = null;
    private _arrPlayerSlot: Array<PlayerSlot> = null;
    private _settings: Settings = null;
    private _backBtn: Button = null;

    private _isPlayAgain: boolean = null;

    private _startText: PIXI.Text = null;
    //private _startBtn: Button = null;

    private _copiedUrlNotification: PIXI.Container = null;

    private _magnifyingGlassTween: gsap.core.Tween = null;
    private _copiedUrlNotificationTl: gsap.core.Timeline = null;

    private _onGameStarted: Signal = null;

    // #endregion //


    public set url( value: string ) { this._url = value; }

    public get onGameStarted(): Signal { return this._onGameStarted; } 


    // #region Methods //

    // public:

    public onEnter(): void
    {
        super.onEnter();        

        Session.i.privateRoomUrl = this._url;

        this._onGameStarted = new Signal();

        this._arrPlayerSlot = [];
        this._isPlayAgain = Session.i.room.length > 1;

        let bg: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.bg.texture );
        bg.anchor.set( 0.5 );
        bg.position.set( ServiceLocator.app.width * 0.5, ServiceLocator.app.height * 0.5 );
        this._root.addChild( bg );

        this._matchmakingReadyAnim = new MatchmakingReadyAnim();
        this._matchmakingReadyAnim.playerSlots = this._arrPlayerSlot;
        this._matchmakingReadyAnim.init();
        this._root.addChild( this._matchmakingReadyAnim );
        this._matchmakingReadyAnim.visible = false;

        this._headerText = new PIXI.Text( "Play with Friends", { fontFamily: "asap_bold", fontSize: 50, fill: 0xffffdf } );
        this._headerText.anchor.set( 0.5 );
        this._headerText.position.set( ServiceLocator.app.width * 0.5, 218 );
        this._root.addChild( this._headerText );

        const kArrPos: Array<PIXI.Point> = [ 
            new PIXI.Point( ServiceLocator.app.width * 0.5, 764 ),
            new PIXI.Point( 105, 550 ),
            new PIXI.Point( 526, 550 ),
            new PIXI.Point( ServiceLocator.app.width * 0.5, 354 ) ];
        for ( let i: number = 0; i < Session.i.kGameRoomSize; ++i )
        {
            let playerSlot: PlayerSlot = new PlayerSlot();
            playerSlot.position.copyFrom( kArrPos[ i ] );
            this._root.addChild( playerSlot );            
            //
            this._arrPlayerSlot.push( playerSlot );
        }
        this._arrPlayerSlot[ 0 ].setPlayer( Session.i.profile );
        this._arrPlayerSlot[ 0 ].scale.set( 1.2 );
        //
        if ( this._isPlayAgain )
        {
            this._updateOtherPlayerSlots();
        }

        this._backBtn = new Button( { on: "button_back", pressed: "button_back_pressed" } );
        this._backBtn.anchor.set( 0.5 );
        this._backBtn.position.set( 58 );
        this._root.addChild( this._backBtn );
        this._backBtn.on( "pointertap", () => { 
            this._root.interactiveChildren = false;
            if ( window.GameSnacks )
            {
                window.GameSnacks.liveMultiplayer.updatePlayerPresence( LivePresenceAction.LEAVE )
                    .then( () => {
                        this._onClosed.dispatch( this ); 
                    } );
            }
            else
            {
                this._onClosed.dispatch( this ); 
            }
        } );

        this._magnifyingGlass = new PIXI.Sprite( ServiceLocator.resources.magnifying_glass.texture );
        this._magnifyingGlass.anchor.set( 70/173, 68/206 );
        this._magnifyingGlass.position.set( ServiceLocator.app.width * 0.5 - 40, 577 );
        this._root.addChild( this._magnifyingGlass );
        //
        this._magnifyingGlassTween = gsap.to( {}, { duration: 2, repeat: -1, onUpdate: () => {
            let m: PIXI.Matrix = PIXI.Matrix.IDENTITY.clone();
            m.tx = -40;
            m.rotate( this._magnifyingGlassTween.progress() * Math.PI * 2 );
            
            this._magnifyingGlass.position.set( ServiceLocator.app.width * 0.5 + m.tx, 577 + m.ty );
        } } );

        this._settings = new Settings();
        this._settings.init( false );
        this._settings.position.set( ServiceLocator.app.width - 58, 58 );
        this._root.addChild( this._settings );
        this._settings.onTutorial.add( () => { 
            ServiceLocator.app.hidePrivateGameShareUrlDiv();

            let tutorialPopup: TutorialPopup = new TutorialPopup();
            tutorialPopup.init();
            this._root.addChild( tutorialPopup );
            tutorialPopup.onClosed.add( ( popup: TutorialPopup ) => {
                popup.end();

                /*if ( !this._isPlayAgain || this._isPlayAgain && Session.i.room.length < Session.i.kGameRoomSize - 1 )
                {*/
                    ServiceLocator.app.showPrivateGameShareUrlDiv( this._url );
                //}
            } );
        } );
        //
        const kSettingsScale: number = 100 / this._settings.width;
        this._settings.position.x -= 58 * ( kSettingsScale - 1 ); 
        this._settings.position.y += 58 * ( kSettingsScale - 1 ) - 4; 
        this._settings.scale.set( kSettingsScale );

        /*this._startBtn = new Button( { on: "button_play" } );
        this._startBtn.anchor.set( 0.5 );
        this._startBtn.position.set( ServiceLocator.app.width * 0.5, 1062 );
        this._root.addChild( this._startBtn );
        this._startBtn.on( "pointertap", this._onStartBtn_Click, this );
        this._startBtn.visible = false;
        if ( this._isPlayAgain )
        {
            let isRoomReady: boolean = true;
            for ( let profile of Session.i.room )
            {
                if ( !profile.isReady )
                {
                    isRoomReady = false;
                    break;
                }
            }
            this._startBtn.visible = isRoomReady;
        }

        this._startText = new PIXI.Text( "All players ready! Let's play!", { fontFamily: "asap_regular", fontSize: 38, fill: 0xffffdf } );
        this._startText.visible = this._startBtn.visible;
        this._startText.anchor.set( 0.5 );
        this._startText.position.set( ServiceLocator.app.width * 0.5, 970 );
        this._root.addChild( this._startText );*/

        this._copiedUrlNotification = new PIXI.Container();
        this._copiedUrlNotification.visible = false;
        this._copiedUrlNotification.position.set( ServiceLocator.app.width * 0.5, ServiceLocator.app.height * 0.5 );
        this._root.addChild( this._copiedUrlNotification );
        //
        let notificationBase: PIXI.Graphics = new PIXI.Graphics();
        notificationBase.beginFill( 0x323c6a, 0.9 );
        const kHalfWidth: number = 200;
        const kHalfHeight: number = 40;
        notificationBase.drawRoundedRect( -kHalfWidth, -kHalfHeight, kHalfWidth * 2, kHalfHeight * 2, 30 );
        notificationBase.endFill();
        this._copiedUrlNotification.addChild( notificationBase );
        //
        let notificationText: PIXI.Text = new PIXI.Text( "Link Copied!", { fontFamily: "asap_regular", fontSize: 40, fill: 0xffffdf } );
        notificationText.anchor.set( 0.5 );
        this._copiedUrlNotification.addChild( notificationText );

        ServiceLocator.app.showPrivateGameShareUrlDiv( this._url );
        if ( !this._isPlayAgain || this._isPlayAgain && Session.i.room.length < Session.i.kGameRoomSize - 1 )
        {
            ServiceLocator.app.hidePrivateGamePlayButton();
        }
        else 
        {
            let isRoomReady: boolean = true;
            for ( let profile of Session.i.room )
            {
                if ( !profile.isReady )
                {
                    isRoomReady = false;
                    break;
                }
            }
            if ( isRoomReady )
            {
                ServiceLocator.app.showPrivateGamePlayButton();
            }
        }
        ServiceLocator.app.onCopyUrlBtnClick.add( this._onCopyUrlBtn_Click, this );
        ServiceLocator.app.onPlayBtnClick.add( this._onStartBtn_Click, this );

        ServiceLocator.multiplayerEventManager.onPlayerPresenceUpdated.add( this._onMultiplayer_PlayerPresenceUpdated, this );
        ServiceLocator.multiplayerEventManager.onEventsReceived.add( this._onMultiplayer_EventsReceived, this );
        ServiceLocator.multiplayerEventManager.onProfileChange.add( this._onProfile_Changed, this );
    }

        private _onCopyUrlBtn_Click(): void
        {
            if ( this._root.interactiveChildren )
            {
                this._root.interactiveChildren = false;

                window.GameSnacks.liveMultiplayer.getRoomUrl()
                    .finally( () => { 
                        this._copiedUrlNotification.position.set( ServiceLocator.app.width * 0.5, ServiceLocator.app.height * 0.5 );
                        this._copiedUrlNotification.visible = true;
                        this._copiedUrlNotification.scale.set( 0 );
                        this._copiedUrlNotification.alpha = 0;
                        //
                        if ( this._copiedUrlNotificationTl )
                        {
                            this._copiedUrlNotificationTl.play( 0 );
                        }
                        else
                        {
                            this._copiedUrlNotificationTl = new gsap.core.Timeline();
                            this._copiedUrlNotificationTl.to( this._copiedUrlNotification.scale, { x: 1, y: 1, duration: 0.4, ease: "back.out" }, 0 );
                            this._copiedUrlNotificationTl.to( this._copiedUrlNotification, { alpha: 1, duration: 0.1, ease: "sine.in" }, 0 );
                            this._copiedUrlNotificationTl.call( () => { 
                                this._root.interactiveChildren = true; 
                            }, null );
                            this._copiedUrlNotificationTl.to( this._copiedUrlNotification, { alpha: 0, duration: 0.6, ease: "sine.in" }, ">+0.2" );
                        }
                    } );
            }
        }

        private _onMultiplayer_PlayerPresenceUpdated( presenceEventPromise: Promise<LivePlayerDataEvent> ): void
        {
            presenceEventPromise
                .then( ( livePlayerDataEvent: LivePlayerDataEvent ) => {
                    if ( livePlayerDataEvent.action == LivePresenceAction.JOIN )
                    {
                        if ( livePlayerDataEvent.isHost )
                        {
                            Session.i.profile.uid = livePlayerDataEvent.uid;
                        }
                        else
                        {
                            if ( Session.i.room.length < Session.i.kGameRoomSize )
                            {
                                let profile: Profile = livePlayerDataEvent.profile;
                                profile.uid = livePlayerDataEvent.uid;
                                Session.i.room.push( livePlayerDataEvent.profile );

                                this._updateOtherPlayerSlots();

                                window.GameSnacks.liveMultiplayer.sendEvent( { payload: JSON.stringify( { type: game_event_type.PRIVATE_ROOM_ACCESS_GRANTED, uid: livePlayerDataEvent.uid, room: Session.i.room.slice(), url: this._url } ) } );
                            }
                            else
                            {
                                window.GameSnacks.liveMultiplayer.sendEvent( { payload: JSON.stringify( { type: game_event_type.PRIVATE_ROOM_FULL, uid: livePlayerDataEvent.uid } ) } );
                            }
                        }
                    }
                    else if ( livePlayerDataEvent.action == LivePresenceAction.LEAVE )
                    {
                        if ( Session.i.profile.uid != livePlayerDataEvent.uid )
                        {
                            for ( let i: number = 0; i < Session.i.room.length; ++i )
                            {
                                if ( Session.i.room[ i ].uid == livePlayerDataEvent.uid )
                                {
                                    if ( Session.i.isGameStarted )
                                    {
                                        Session.i.room[ i ].isBot = true;
                                    }
                                    else
                                    {
                                        Session.i.room.splice( i, 1 );
                                    }
                                    break;
                                }
                            }

                            if ( !Session.i.isGameStarted )
                            {
                                this._magnifyingGlass.visible = Session.i.room.length < Session.i.kGameRoomSize - 1;
                                if ( !this._magnifyingGlass.visible )
                                {
                                    ServiceLocator.app.showPrivateGamePlayButton();
                                }
                                else
                                {
                                    ServiceLocator.app.hidePrivateGamePlayButton();
                                }

                                this._updateOtherPlayerSlots();
                            }
                        }
                    }
                } );
        }

            private _updateOtherPlayerSlots(): void
            {
                for ( let i: number = 1; i < Session.i.kGameRoomSize; ++i )
                {
                    this._arrPlayerSlot[ i ].empty();
                }

                let myProfileIndex: number = 0;
                while ( Session.i.room[ myProfileIndex ].uid != Session.i.profile.uid )
                {
                    myProfileIndex += 1;
                }

                let playerCount: number = 1;
                let playerProfileIndex: number = myProfileIndex + 1;
                if ( playerProfileIndex > Session.i.room.length - 1 )
                {
                    playerProfileIndex = 0;
                }
                let playerSlotIndex: number = 1;
                //
                while ( playerCount < Session.i.room.length )
                {
                    this._arrPlayerSlot[ playerSlotIndex ].setPlayer( Session.i.room[ playerProfileIndex ] );

                    playerProfileIndex += 1;
                    if ( playerProfileIndex > Session.i.room.length - 1 )
                    {
                        playerProfileIndex = 0;
                    }
                    playerSlotIndex += 1;

                    playerCount += 1;
                }
            }

        private _onMultiplayer_EventsReceived( eventsPromise: Promise<LiveEventData[]> ): void
        {
            eventsPromise
                .then( ( arrData: LiveEventData[] ) => {
                    while ( arrData.length > 0 )
                    {
                        let data: LiveEventData = arrData.shift();
                        if ( data.payload === undefined )
                        {
                            Session.i.gameEvents.push( data );
                        }
                        else
                        {
                            let payload: any = null;
                            try
                            {
                                payload = JSON.parse( data.payload );
                            }
                            catch ( ex )
                            {
                                payload = null;
                            }
                            if ( payload !== null && payload.type === game_event_type.JOINED_PRIVATE_ROOM )
                            {
                                for ( let profile of Session.i.room )
                                {
                                    if ( profile.uid == payload.uid )
                                    {
                                        profile.isReady = true;
                                        break;
                                    }
                                }
                                if ( Session.i.room.length >= Session.i.kGameRoomSize - 1 )
                                {
                                    if ( this._isPlayAgain )
                                    {
                                        let isRoomReady: boolean = true;
                                        for ( let profile of Session.i.room )
                                        {
                                            if ( !profile.isReady )
                                            {
                                                isRoomReady = false;
                                                break;
                                            }
                                        }
                                        if ( isRoomReady )
                                        {
                                            this._magnifyingGlass.visible = false;
                                            ServiceLocator.app.showPrivateGamePlayButton();
                                        }
                                    }
                                    else
                                    {
                                        this._magnifyingGlass.visible = false;
                                        ServiceLocator.app.showPrivateGamePlayButton();
                                    }
                                }
                            }
                        }
                    }
                } );
        }

        private _onStartBtn_Click(): void
        {
            Session.i.isGameStarted = true; 
            
            ServiceLocator.app.hidePrivateGameShareUrlDiv();

            const kSeed: number = Math.floor( Math.random() * 9999 );
            let arrProfile: Array<Profile> = [];
            arrProfile.push( Session.i.room[ 0 ] );
            arrProfile.push( Session.i.room[ 1 ] );
            if ( Session.i.room.length == 4 )
            {
                arrProfile.push( Session.i.room[ 3 ] );
            }
            arrProfile.push( Session.i.room[ 2 ] );

            Session.i.room = arrProfile;
            
            if ( arrProfile.length < Session.i.kGameRoomSize )
            {
                this._arrPlayerSlot[ 3 ].visible = false;
                //this._arrPlayerSlot[ 2 ].position.copyFrom( this._arrPlayerSlot[ 3 ].position );*/
            }
            //
            if ( this._isPlayAgain )
            {
                window.GameSnacks.liveMultiplayer.sendEvent( { 
                    payload: JSON.stringify( { 
                        type: game_event_type.PLAY_AGAIN_PRIVATE_GAME, 
                        uid: Session.i.profile.uid,
                        seed: kSeed,
                        room: arrProfile } ) 
                } );
            }
            else
            {
                window.GameSnacks.liveMultiplayer.sendEvent( { 
                    type: LiveEventDataType.START_GAME,
                    payload: JSON.stringify( { seed: kSeed, room: arrProfile } )
                } );
            }

            Session.i.prng = new PRNG( kSeed );

            if ( this._magnifyingGlassTween )
            {
                this._magnifyingGlassTween.kill();
                this._magnifyingGlassTween = null;
            }
            this._magnifyingGlass.visible = false;
            //
            this._headerText.visible = false;
            this._backBtn.visible = false;
            this._settings.visible = false;

            this._matchmakingReadyAnim.visible = true;
            let tl: gsap.core.Timeline = this._matchmakingReadyAnim.play();
            tl.call( () => { this._onGameStarted.dispatch( this ); } );
        }

        private _onProfile_Changed( profile: Profile): void
        {
            Session.i.profile = profile;

            this._arrPlayerSlot[ 0 ].setPlayer( Session.i.profile )
        }

    public onLeave(): void
    {
        this._onGameStarted.dispose();
        this._onGameStarted = null;

        ServiceLocator.app.onCopyUrlBtnClick.remove( this._onCopyUrlBtn_Click, this );

        ServiceLocator.multiplayerEventManager.onPlayerPresenceUpdated.removeAll();
        ServiceLocator.multiplayerEventManager.onEventsReceived.removeAll();
        ServiceLocator.multiplayerEventManager.onProfileChange.remove( this._onProfile_Changed, this );

        Session.i.isGameStarted = false;

        ServiceLocator.app.hidePrivateGameShareUrlDiv();

        if ( this._magnifyingGlassTween )
        {
            this._magnifyingGlassTween.kill();
            this._magnifyingGlassTween = null;
        }

        this._matchmakingReadyAnim.end();
        this._matchmakingReadyAnim = null;

        if ( this._copiedUrlNotificationTl )
        {
            this._copiedUrlNotificationTl.kill();
            this._copiedUrlNotificationTl = null;
        }

        this._settings.end();
        this._settings = null;

        super.onLeave();
    }

    public onUpdate( dt: number ): void
    {
        if ( this._matchmakingReadyAnim.visible ) 
        { 
            this._matchmakingReadyAnim.update( dt );
        }
    }

    public checkPrivateRoomReady(): void
    {
        if ( Session.i.room.length >= Session.i.kGameRoomSize - 1 )
        {
            let isRoomReady: boolean = true;
            for ( let profile of Session.i.room )
            {
                if ( !profile.isReady )
                {
                    isRoomReady = false;
                    break;
                }
            }
            this._magnifyingGlass.visible = !isRoomReady;
            if ( isRoomReady )
            {
                ServiceLocator.app.showPrivateGamePlayButton();
            }
            else
            {
                ServiceLocator.app.hidePrivateGamePlayButton();
            }
        }
        else
        {
            ServiceLocator.app.hidePrivateGamePlayButton();
        }
    }

    // #endregion //
}